<template>
  <div v-if="orderItem.cost_subtotal" class="border border-grey-light mb-8">
    <div class="w-full flex text-sm p-4 bg-grey-lighter border-t-2 border-print-order-teal">
      <strong class="h-6">Item Summary</strong>
    </div>
    <div class="px-4 pt-6">
      <h4 class="block text-sm pb-3">Total</h4>
      <table class="w-full mb-4">
        <tbody>
          <tr>
            <td class="align-top text-sm pb-2">
              Subtotal
            </td>
            <td class="align-top text-right text-sm pb-2">{{ orderItem.cost_subtotal | gbp }}</td>
          </tr>
          <tr>
            <td class="align-top text-sm pb-3">
              VAT (20%)
            </td>
            <td class="align-top text-right text-sm pb-3">{{ orderItem.cost_vat | gbp }}</td>
          </tr>
          <tr>
            <td class="align-top text-sm font-bold pb-1">
              Total
            </td>
            <td class="align-top text-right text-sm font-bold pb-1">{{ orderItem.cost_total | gbp }}</td>
          </tr>
          <tr v-if="orderItem.sale_item.additional_delivery_charges_apply">
            <td colspan="2" class="align-top text-right text-sm pb-2">+ unknown delivery charge</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loaded: true
    }
  },
  props: ['orderItem'],
  computed: {
  },
  methods: {
  }
}
</script>
